import createReactComponent from '../createReactComponent';
var Wand = createReactComponent('Wand', [['path', {
  d: 'M15 4V2',
  key: 'z1p9b7'
}], ['path', {
  d: 'M15 16v-2',
  key: 'px0unx'
}], ['path', {
  d: 'M8 9h2',
  key: '1g203m'
}], ['path', {
  d: 'M20 9h2',
  key: '19tzq7'
}], ['path', {
  d: 'M17.8 11.8 19 13',
  key: 'yihg8r'
}], ['path', {
  d: 'M15 9h0',
  key: 'kg5t1u'
}], ['path', {
  d: 'M17.8 6.2 19 5',
  key: 'fd4us0'
}], ['path', {
  d: 'm3 21 9-9',
  key: '1jfql5'
}], ['path', {
  d: 'M12.2 6.2 11 5',
  key: 'i3da3b'
}]]);
export default Wand;